import React, { useEffect, useState } from 'react';
import { MDBContainer, } from 'mdb-react-ui-kit';
import BreadCrumbs from '../components/breadcrumbs';
import Banner from '../components/img_banner';
import DownContact from '../components/downcontact';
import Info from '../components/services_credentialing_info';
import Desc from '../components/services_credentialing_desc';
import { Helmet } from 'react-helmet';
import RCMcy from '../images/servicesMain_Banner/credentialservice.webp';
import ReactGA from 'react-ga';
ReactGA.initialize('G-7WQFXCQFVP');

const Credentialing = () => {
  useEffect(() => {
    // change title of page
    document.title = 'Medical Billing And Credentialing Services | AcerHealth';

    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7WQFXCQFVP';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-7WQFXCQFVP');
  }, []);

  // Set breadcrumb
  const [Breadcrumb, setBreadcrumb] = useState('Credentialing Services');

  // Set Banner Title
  const [BannerTitle, setBannerTitle] = useState({ title: "Credentialing Services", subtitle: "Simplify Credential Upkeep for Seamless payer Interactions with Hassle-free Maintenance.", img: `url(${RCMcy})` });

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({ title: "Looking to outsource your provider credentialing? Contact us today to learn how AcerHealth can streamline the process for you.", subtitle: "" });


  return (
    <>

      <Helmet>
        <title> Medical Billing & Credentialing | AcerHealth Services</title>
        <link rel="canonical" href="https://acerhealth.com/services/medical-billing-and-credentialing" />
        <meta name="description" content="Get complete medical billing and credentialing services with AcerHealth to boost reimbursements, reduce denials, and speed up provider onboarding." />
        <meta name="keywords" content="Medical Billing Credentialing Services" />
      </Helmet>
      {/* <BreadCrumbs Breadcrumb ={Breadcrumb} /> */}
      <Banner BannerTitle={BannerTitle} />
      <Info />
      <Desc />
      <DownContact DownContactTitle={DownContactTitle} />
  
    </>
  );
};

export default Credentialing;